import { useCurrentUserInfo } from '@/auth/hooks';

/**
 * Returns the current organization cmId.
 */
export const useOrganizationCmId = (): string => {
  const userInfo = useCurrentUserInfo();
  return userInfo.currentOrgCmId!;
};
